export default __webpack_public_path__ + "static/alfred_shutdown-00b545b34bd1019fc8497239755d10e6.png";